export type AuthData = {accessToken: string | null}; // allow null to work w axios-oauth AuthData response

const authDataKey = "A_DATA";

export function setAuthData(newAuthData: AuthData | undefined) {
  if (!newAuthData) {
    return localStorage.removeItem(authDataKey);
  }
  localStorage.setItem(authDataKey, JSON.stringify(newAuthData));
}

export function getAuthData(): AuthData | undefined {
  try {
    const strData = localStorage.getItem(authDataKey);
    if (!strData) {
      return undefined;
    }
    return JSON.parse(strData);
  } catch {
    return undefined;
  }
}
